import React from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import BigQueryDatasetSelector from 'components/bigquery/BigQueryDatasetSelector';
import BigQueryTableSelector from 'components/bigquery/BigQueryTableSelector';
import SyncWizardFooterWrapper from 'components/SyncWizardFooterWrapper';

export const CrosstabsStep1 = ({
  projectId,
  crosstabName,
  setCrosstabName,
  selectedDataset,
  setSelectedDataset,
  surveyResponseTable,
  setSurveyResponseTable,
  questionLabelsTable,
  setQuestionLabelsTable,
  responseLabelsTable,
  setResponseLabelsTable,
  showErrors,
  onNext
}) => {
  const handleSelectDataset = (event, value) => {
    // Reset table selections when dataset changes
    setSurveyResponseTable(null);
    setQuestionLabelsTable(null);
    setResponseLabelsTable(null);
    setSelectedDataset(value);
  };

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto' }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h3" sx={{ mb: 1 }}>
          Name Crosstab & select data source
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary', fontStyle: 'italic' }}>
          Choose dataset and table in PAD where your survey data lives
        </Typography>

        {/* Crosstab Name Input */}
        <TextField
          fullWidth
          label="Crosstab Name"
          value={crosstabName}
          onChange={(e) => setCrosstabName(e.target.value)}
          error={showErrors && crosstabName.trim() === ''}
          helperText={showErrors && crosstabName.trim() === '' ? 'Please enter a crosstab name' : ' '}
          sx={{ mb: 3 }}
        />

        <Typography variant="body1" sx={{ mb: 2 }}>
          Select data sources from PAD
        </Typography>

        {/* Dataset Selector */}
        <BigQueryDatasetSelector
          selectedDataset={selectedDataset}
          onSelectDataset={handleSelectDataset}
          showError={showErrors}
          label="Select dataset"
        />

        {/* Survey Response Table Selector */}
        <BigQueryTableSelector
          datasetId={selectedDataset}
          selectedTable={surveyResponseTable}
          onSelectTable={(event, value) => setSurveyResponseTable(value)}
          showError={showErrors}
          label="Select survey response table"
        />

        {/* Question Labels Table Selector */}
        <BigQueryTableSelector
          datasetId={selectedDataset}
          selectedTable={questionLabelsTable}
          onSelectTable={(event, value) => setQuestionLabelsTable(value)}
          showError={showErrors}
          label="Select question labels table"
        />

        {/* Response Labels Table Selector */}
        <BigQueryTableSelector
          datasetId={selectedDataset}
          selectedTable={responseLabelsTable}
          onSelectTable={(event, value) => setResponseLabelsTable(value)}
          showError={showErrors}
          label="Select response labels table"
        />

        {/* Next Button */}
        <SyncWizardFooterWrapper sxOverrides={{ justifyContent: "flex-end", mt: 4 }}>
          <Button
            variant="contained"
            onClick={onNext}
            size="large"
            sx={{ 
              px: 4,
              py: 1.5,
              fontSize: '1rem',
              backgroundColor: 'grey.600',
              '&:hover': {
                backgroundColor: 'grey.700'
              }
            }}
          >
            Next: Map Source Data
          </Button>
        </SyncWizardFooterWrapper>
      </Box>
    </Box>
  );
};

export default CrosstabsStep1;